"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var SpecialCoverageCatalog_1 = require("../models/SpecialCoverageCatalog");
var mockSpecialCoverageCatalog = __assign(__assign({}, SpecialCoverageCatalog_1.makeEmptySpecialCoverageCatalog()), { label: 'foo-special-label', content: 'foo-special-content' });
exports.default = mockSpecialCoverageCatalog;
//# sourceMappingURL=mockSpecialCoverageCatalog.js.map